var exports = {
  "DD": "x234b8571--fd1a34--title",
  "q_": "x234b8571--fd1a34--title-link",
  "p_": "x234b8571--fd1a34--list",
  "x3": "x234b8571--fd1a34--list-item",
  "nf": "x234b8571--fd1a34--link",
};

module.exports = exports;
